export default function isDark(hexString: string) {
  return !(parseInt(hexString.replace('#', ''), 16) > 0xffffff / 2);
}
